import { Controller } from "@hotwired/stimulus"

// Generic "create a related record without leaving this form" modal.
// Registered under one identifier per modal on the page (quick-add for the
// brand modal, contact-quick-add for the contact one) because Stimulus allows
// only a single instance of an identifier per element.
export default class extends Controller {
  static targets = ["dialog"]

  open() { this.dialogTarget.classList.remove("hidden") }
  close() { this.dialogTarget.classList.add("hidden") }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }

  closeOnSuccess(event) {
    if (event.detail.success) this.close()
  }
}
